import Joi, { Extension, Root } from 'joi';
import { ICAL } from '~/shared/src/utilities/icalParser.js';
import { enumerate } from "ts-transformer-enumerate";


interface YnStringSchema extends Joi.StringSchema {
    timezone(): this;
    ynSchema(): this;
}

interface ExtendedJoi extends Joi.Root {
    string(): YnStringSchema;
}

export default Joi.extend( ( joi: Root ): Extension => {
    return {
        type: 'string',
        base: joi.string(),
        messages: {
            'string.timezone': '{{#label}} must be a valid timezone name',
            'string.ynSchema': '{{#label}} must be a valid db schema'
        },
        rules: {
            timezone: {
                /**
                 * Validation method for Joi.string().timezone()
                 *
                 * @param value
                 * @param helpers
                 *
                 * @return {any}
                 */
                validate( value, helpers /*, args, options*/ ) {
                    if ( !ICAL.TimezoneService.has( value ) ) {
                        return helpers.error( 'string.timezone' );
                    }

                    return value;
                }
            },
            ynSchema: {
                /**
                 * Validation method for Joi.string().ynSchema()
                 *
                 * @param value
                 * @param helpers
                 *
                 * @return {any}
                 */
                validate( value, helpers ) {
                    if ( !enumerate<YnSchema>().includes( value ) ) {
                        return helpers.error( 'string.ynSchema' );
                    }
                    return value;
                }
            }
        }
    };
} ) as ExtendedJoi;
